import { useCallback } from "react";
import { useAuthFetch } from "../utils/useAuthFetch";

export type OrgHeartbeatKind = "cron" | "wakeup";
export type OrgHeartbeatStatus =
  | "pending"
  | "running"
  | "completed"
  | "cancelled"
  | "failed"
  | "expired"
  | string;

export interface OrgHeartbeatOverviewItem {
  user_name: string;
  workspace_name: string;
  title: string | null;
  frequency: string;
  kind: OrgHeartbeatKind;
  status: OrgHeartbeatStatus;
}

export interface OrgHeartbeatsOverviewResponse {
  items: OrgHeartbeatOverviewItem[];
  total: number;
}

export const useOrgHeartbeatsOverview = () => {
  const authFetch = useAuthFetch();

  return useCallback(
    async (orgId: string): Promise<OrgHeartbeatsOverviewResponse> => {
      return (await authFetch(
        `/api/organization/${orgId}/heartbeats-overview`,
        "fetch org heartbeats overview",
      )) as OrgHeartbeatsOverviewResponse;
    },
    [authFetch],
  );
};
